export const Name = 'rcs-invite-content';

export enum VariantType {
  Control = 'control',
  AutoAcceptCard = 'test',
  ViewOnlyCard = 'test_b',
  PlainText = 'test_c',
}
